import { axiosApiInstance } from "../axios";
import { isInactiveTenantResponse } from "../shared/tenantApiErrors";
import { logout } from "../store/actions/auth";

export function setupAxiosInterceptors(store) {
  axiosApiInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (isInactiveTenantResponse(error)) {
        alert(
          error.response?.data?.message ||
            "This company account is inactive. Please contact QA Trace support.",
        );
        store.dispatch(logout());
      }
      return Promise.reject(error);
    },
  );
}

export { isInactiveTenantResponse };
